/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http.get('/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      });
  }

  getPhoneNumber(): string {
    if (!this.config) {
      throw new Error('Configuration not loaded yet!');
    }
    return this.config.whatsappNumber;
  }

  getMessage(): string {
    if (!this.config) {
      throw new Error('Configuration not loaded yet!');
    }
    return this.config.whatsappMessage;
  }

  getConfig(): string {
    if (!this.config) {
      throw new Error('Configuration not loaded yet!');
    }
    return this.config.apiUrl;
  }
}
